import React, { useMemo, useState } from 'react';
import { Layout, Tabs } from 'tea-component';

import '@/pages/opinion/assets/scss/pages/competitor/index.scss';
import TrendsAnalysis from './page/TrendsAnalysis';
import ComparisonOverview from './page/ComparisonOverview';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';
import { connect, getLocale, useIntl } from 'umi';
import CardLoading from '../../components/CardLoading';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import CompetitorPoint from '@op/operationLog/pages/competitor';
import useTranslateTopic from '../../hooks/useTranslateTopic';
import { useNavigatorScroll } from '../../components/Navigator';
import ContentBody from '../../components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

function Competitor({ gameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: CompetitorPoint });
  const [activeId, setActiveId] = useState('Comparison Overview');
  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
  };

  const { formatMessage } = useIntl();

  const options = useMemo(
    () => [
      {
        text: formatMessage({ id: 'Mentions & Sentiment' }),
        value: 'mentions',
      },
      {
        text: formatMessage({ id: 'Topic' }),
        value: 'topic',
      },
      {
        text: formatMessage({ id: 'Keywords' }),
        value: 'keywords',
      },
      {
        text: formatMessage({ id: 'Game Store' }),
        value: 'gameStore',
      },
      {
        text: formatMessage({ id: 'Channel' }),
        value: 'channel',
      },
      {
        text: formatMessage({ id: 'Language' }),
        value: 'language',
      },
      {
        text: formatMessage({ id: 'Region / Country' }),
        value: 'region',
      },
    ],
    [formatMessage],
  );

  const lang = getLocale();
  const { translateTopicFunc, setTranslateTopicMap } = useTranslateTopic(lang);
  const { loading, filter, changeFilter, filterOptions } = useFilterDataHook({
    pageName: 'Competitor',
    gameInfo,
  });

  const tabs = useMemo(
    () => [
      {
        id: 'Comparison Overview',
        label: formatMessage({ id: 'Comparison Overview' }),
        Component: ComparisonOverview,
      },
      {
        id: 'Trends Analysis',
        label: formatMessage({ id: 'Trends Analysis' }),
        Component: TrendsAnalysis,
      },
    ],
    [formatMessage],
  );

  const { selectNavigator, setSelectNavigator, handleScroll, scrollBody } =
    useNavigatorScroll({
      allKeys: options.map((item) => item.value),
      defaultValue: 'mentions',
    });

  return (
    // contentHead-normal 带有tab的样式
    <Content
      className="dbo-competitor"
      ref={scrollBody}
      onScrollCapture={handleScroll}
    >
      <ContentBody
        pageName={PAGE_NAME.COMPETITOR}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: PAGE_NAME.COMPETITOR })}
            className="dbo-header contentHead-normal"
          >
            {/* 注释 tab 也要 去掉  dbo-header后面 contentHead-normal 类名  */}
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
          </Content.Header>
        }
      >
        <FilterFixed
          filter={filterOptions}
          renderExcludeFilter={['topic']}
          operateShowOptions={['save', 'more', 'history', 'tips']}
          hasLaunchTime={false}
          confirm={(value) => {
            changeFilter({
              ...value,
              ...gameInfo,
              social_media_by_account: ['99999'],
              social_media_by_keyword: ['99999'],
              external_data_sources: ['99999'],
            });
          }}
          backCondOriginData={(value) => {
            setTranslateTopicMap(value.topic_trans);
          }}
        ></FilterFixed>

        <CardLoading loading={loading}>
          {activeId === 'Comparison Overview' && (
            <ComparisonOverview
              filter={filter}
              gameInfo={gameInfo}
              translateTopicFunc={translateTopicFunc}
            ></ComparisonOverview>
          )}
          {activeId === 'Trends Analysis' && (
            <TrendsAnalysis
              filter={filter}
              selectNavigator={selectNavigator}
              setSelectNavigator={setSelectNavigator}
              gameInfo={gameInfo}
              scrollBody={scrollBody}
              options={options}
              translateTopicFunc={translateTopicFunc}
            ></TrendsAnalysis>
          )}
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
  };
})(Competitor);
